export const SUBMIT_EMAIL = 'SUBMIT_EMAIL';

const hostname = window.location.hostname;
const isProduction = /dreamstation.frame.io/.test(hostname);
const apiUrl = isProduction
  ? 'https://api.frame.io/dreamstation/enrollments'
  : 'https://api-v2.dev.frame.io/dreamstation/enrollments';

function _submitEmail(payload, emailAddress, position) {
  return { type: SUBMIT_EMAIL, payload, meta: { emailAddress, position } };
}

export const submitEmail = (emailAddress, position) => (dispatch) => {
  let payload = fetch(apiUrl, {
    method: 'post',
    body: JSON.stringify({ email: emailAddress }),
    headers: {
      "Content-Type": "application/json"
    },
  }).then(response => {
    return response.json().then(json => {
      if (response.status !== 200) throw json;
      return json;
    });
  });
  return dispatch(_submitEmail(payload, emailAddress, position));
}



// WEBPACK FOOTER //
// ./src/state/actions/homeActions.js